import { Toggle, ToggleGroup, Translation } from '@ps/web-shared-components';
import React, { useCallback, useState } from 'react';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import DOB from '../../../DOB/DOB';
import InfoPrompt from '../../../InfoPrompt/InfoPrompt';

import {
  TXTCLI_If_you_are_on_that_list_you_wi_ELL,
  TXTCLI_PINX_This_is_a_number_issued_t_ELL,
  TXTCLI_PIN_types,
  TXTCLI_PNF_LNCHX_If_you_are_not_a_lon_ELL,
  TXTCLI_Personal_Identification_Number_ELL,
  TXTCLI_Personal_Identification_Number_ELL_1,
  TXTCLI_Personal_Number_of_Foreigner_X_ELL,
  TXTCLI_UCN_EGNX_For_permanent_residen_ELL,
  TXTCLI_Unified_Civil_Number_XUCN_EGNX,
  TXTCLI_We_need_this_information_to_ve_ELL,
  TXTCLI_What_is_your_Personal_Identifi_ELL,
  TXTCLI_Your_PIN_1
} from './SignupPIN.messages.json';
import { infoPrompt, toggleLabel } from './SignupPIN.scss';
import Confirmation from './components/Confirmation/Confirmation';
import PIN from './components/PIN/PIN';
import PNF from './components/PNF/PNF';
import UCN from './components/UCN/UCN';

enum FiscalCodeType {
  UCN = 'UCN',
  PIN = 'PIN',
  PNF = 'PNF'
}

const SignupPIN: React.FunctionComponent = () => {
  const [fiscalType, setFiscalType] = useState<FiscalCodeType>(FiscalCodeType.UCN);
  const getPINField = useCallback(() => {
    switch (fiscalType) {
      case FiscalCodeType.UCN: {
        return <UCN />;
      }
      case FiscalCodeType.PIN: {
        return <PIN />;
      }
      default: {
        return <PNF />;
      }
    }
  }, [fiscalType]);
  return (
    <Container
      page={SignupPIN}
      headerProps={{
        title: <Translation {...TXTCLI_Your_PIN_1} />,
        buttons: { back: true }
      }}
      pageTopTitle={<Translation {...TXTCLI_What_is_your_Personal_Identifi_ELL} />}
      pageTopSubtitle={
        <>
          <Translation {...TXTCLI_We_need_this_information_to_ve_ELL} />{' '}
          <Translation {...TXTCLI_If_you_are_on_that_list_you_wi_ELL} />
        </>
      }
    >
      <ToggleGroup
        id="toggle"
        label={<Translation {...TXTCLI_Personal_Identification_Number_ELL} />}
        labelClassName={toggleLabel}
        labelInfo={
          <InfoPrompt
            title={{ translation: TXTCLI_PIN_types }} // +
          >
            <div className={infoPrompt}>
              <Translation tagName="p" {...TXTCLI_UCN_EGNX_For_permanent_residen_ELL} />{' '}
              <Translation tagName="p" {...TXTCLI_PNF_LNCHX_If_you_are_not_a_lon_ELL} />
              <Translation tagName="p" {...TXTCLI_PINX_This_is_a_number_issued_t_ELL} />
            </div>
          </InfoPrompt>
        }
      >
        <Toggle
          id="ucn"
          name="fiscalCodeType"
          label={<Translation {...TXTCLI_Unified_Civil_Number_XUCN_EGNX} />}
          value={FiscalCodeType.UCN}
          defaultValue={FiscalCodeType.UCN}
          type="radio"
          onChange={() => setFiscalType(FiscalCodeType.UCN)}
          checked={fiscalType === FiscalCodeType.UCN}
        />
        <Toggle
          id="pin"
          name="fiscalCodeType"
          label={<Translation {...TXTCLI_Personal_Identification_Number_ELL_1} />}
          value={FiscalCodeType.PIN}
          type="radio"
          onChange={() => setFiscalType(FiscalCodeType.PIN)}
          checked={fiscalType === FiscalCodeType.PIN}
        />
        <Toggle
          id="pnf"
          name="fiscalCodeType"
          label={<Translation {...TXTCLI_Personal_Number_of_Foreigner_X_ELL} />}
          value={FiscalCodeType.PNF}
          type="radio"
          onChange={() => setFiscalType(FiscalCodeType.PNF)}
          checked={fiscalType === FiscalCodeType.PNF}
        />
      </ToggleGroup>
      <DOB />
      {getPINField()}
      <Confirmation />
      <CTAButton />
    </Container>
  );
};

SignupPIN.displayName = 'SignupPIN';

export default SignupPIN;
